import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "AF_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#AF_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 0h10v24H22V0z",
      fill: "#67BD38"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 0h12v24H10V0z",
      fill: "#D51700"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h10v24H0V0z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.488 7.977l.346.217c-.576.97-.964 1.86-1.164 2.668a.945.945 0 01.191.24c.156.271.288.534.395.79l-.46.195a6.14 6.14 0 00-.254-.53c-.047.393-.044.765.01 1.115a.935.935 0 01.235.056c.294.107.564.224.81.351l-.226.446c-.21-.109-.44-.21-.69-.303l.004.015c.214.646.541 1.24.983 1.783a.956.956 0 01.207-.02c.313 0 .606.018.88.053l-.06.496a6.07 6.07 0 00-.59-.045c.396.396.861.762 1.396 1.097l-.21.356a8.052 8.052 0 01-1.694-1.39c-.061.023-.135.055-.23.096l-.034.015c.406.426.886.817 1.44 1.174l-.216.353a8.147 8.147 0 01-1.644-1.376 1.087 1.087 0 01-.617-.008l.134-.48c.033.01.065.016.097.02a6.215 6.215 0 01-.957-1.842 3.986 3.986 0 01-.097-.358 1.066 1.066 0 01-.45-.2l.29-.407c.025.018.05.035.076.049-.052-.613.02-1.274.214-1.983a1.067 1.067 0 01-.242-.474l.425-.11c.229-.648.553-1.334.97-2.057l.35.212c-.457.79-.794 1.527-1.015 2.212.062.056.138.117.23.185.222-.806.612-1.676 1.167-2.611zm-1.29 3.142a8.115 8.115 0 00-.255-.193c-.154.636-.2 1.224-.138 1.763.075 0 .16-.003.257-.009l.08-.005a4.855 4.855 0 01.057-1.556zm-.114 2.059l.157-.01c.018.069.039.136.06.203a5.99 5.99 0 00.96 1.795l-.084.037c-.07.03-.134.057-.193.08a5.818 5.818 0 01-1.028-1.894 3.498 3.498 0 01-.059-.203c.059-.001.12-.004.187-.008zM19.5 7.977l-.346.217c.577.97.964 1.86 1.164 2.668a.945.945 0 00-.19.24 6.925 6.925 0 00-.395.79l.46.195c.071-.172.156-.35.254-.53.046.393.043.765-.01 1.115a.935.935 0 00-.236.056 6.927 6.927 0 00-.81.351l.227.446c.21-.109.44-.21.69-.303l-.005.015a5.595 5.595 0 01-.982 1.783.956.956 0 00-.207-.02c-.313 0-.607.018-.881.053l.06.496c.186-.024.383-.04.591-.045a7.885 7.885 0 01-1.397 1.097l.211.356a8.052 8.052 0 001.694-1.39c.06.023.135.055.23.096l.034.015a7.872 7.872 0 01-1.44 1.174l.215.353a8.153 8.153 0 001.644-1.376c.218.056.402.055.617-.008l-.134-.48a.67.67 0 01-.096.02 6.21 6.21 0 00.956-1.842c.038-.117.07-.237.097-.358.165-.032.305-.094.45-.2l-.29-.407a.678.678 0 01-.076.049c.052-.613-.02-1.274-.213-1.983.121-.14.196-.285.242-.474l-.426-.11a12.432 12.432 0 00-.97-2.057l-.349.212c.456.79.794 1.527 1.014 2.212a3.073 3.073 0 01-.23.185c-.222-.806-.612-1.676-1.167-2.611zm1.29 3.142a8.115 8.115 0 01.255-.193c.155.636.2 1.224.138 1.763-.075 0-.16-.003-.257-.009l-.08-.005a4.855 4.855 0 00-.056-1.556zm.115 2.059a11.29 11.29 0 00-.158-.01 5.99 5.99 0 01-1.02 1.998l.085.037c.07.03.134.057.192.08a5.818 5.818 0 001.029-1.894c.021-.067.04-.134.058-.203a5.175 5.175 0 01-.186-.008z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.253 16.265l-1.116 1.104s.962.59 2.777.59c1.814 0 2.87-.59 2.87-.59l-.848-1.104s-1.157.448-1.975.448c-.82 0-1.708-.448-1.708-.448z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.277 16.969s.946.223 1.67.223c.725 0 1.67-.223 1.67-.223",
      stroke: "#C00001",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.893 9.459c0 .43-.385.779-.866.791h.874l.313.203h.157V8.868h.486v1.585h.172v.27h-.172v2.874c0 .168.18.458.558.835l.43.43h-5.978l.993-.477c.187-.09.32-.348.378-.804v-2.858h-.425v-.27h.425V8.868h.487v1.585h.052l.264-.203h.934c-.48-.012-.866-.362-.866-.791 0-.438.4-.792.892-.792.493 0 .892.354.892.792zm-2.168 1.264h2.646v2.874c0 .232.11.483.324.765h-3.17c.097-.197.162-.443.2-.75v-2.889zM16.08 12h-1.054v2.083h2.109L16.08 12zM17.17 6.156l.002.003-.002-.003zm1.54.542l.002.01V6.7l-.001-.003zm.3.037l.001-.005v.003l-.001.002zm-1.211.614h.005-.005z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.994 10.668l-.2.143.206.302c-.176.063-.459.223-.459.598 0 .546-.191.993-.191.993l.572.367s.06-.636.215-.998a.584.584 0 01.301-.317l.89 1.306.2-.143-1.534-2.251zM19.072 10.668l.2.143-.205.302c.175.063.458.223.458.598 0 .546.192.993.192.993l-.572.367s-.06-.636-.216-.998a.584.584 0 00-.301-.317l-.89 1.306-.2-.143 1.534-2.251z",
      fill: "#F7FCFF"
    }
  ))
);
export {
  a as default
};
